import { render, staticRenderFns } from "./OneTimeArchive.vue?vue&type=template&id=0335af64&scoped=true&"
import script from "./OneTimeArchive.vue?vue&type=script&lang=js&"
export * from "./OneTimeArchive.vue?vue&type=script&lang=js&"
import style0 from "./OneTimeArchive.vue?vue&type=style&index=0&id=0335af64&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0335af64",
  null
  
)

export default component.exports